import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { EmptyView, withTranslation } from '@piwikpro/ui-components';

const MetaSitesEmpty = withTranslation('administration')(({ t }: any) => (
  <EmptyView text={t('meta-sites.list.emptyMessage')} />
));

export const Route = createFileRoute('/_secured/administration/meta-sites/')({
  component: MetaSitesEmpty,
});
